import type { AuthPort, AuthSession } from './authPort'
import { supabase } from '../database/supabaseClient'

function mapSession(session: Awaited<ReturnType<typeof supabase.auth.getSession>>['data']['session']): AuthSession | null {
  return session ? { user: { id: session.user.id, email: session.user.email ?? undefined } } : null
}

export const authAdapter: AuthPort = {
  async getSession() {
    const { data, error } = await supabase.auth.getSession()
    if (error) throw error
    return mapSession(data.session)
  },
  async signInWithEmail(email, password) {
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) throw error
  },
  async signOut() {
    const { error } = await supabase.auth.signOut()
    if (error) throw error
  },
  onAuthStateChange(handler) {
    const { data } = supabase.auth.onAuthStateChange((_event, session) => handler(mapSession(session)))
    return () => data.subscription.unsubscribe()
  },
}
